import { useQuery } from "react-query";
import queryKeys from "../../../constants/queryKeys";
import caseService from "../../services/caseService";

const useCaseActions = (caseId) =>
  useQuery(
    [queryKeys.caseActions, caseId],
    () => caseService.fetchOpenAndETCaseActions(caseId),
    {
      enabled: !!caseId,
    }
  );

export default useCaseActions;
